var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$root.translations)?_c('div',[_c('div',{ref:"consent"}),_c('pageHeader',{attrs:{"productCats":_vm.productCats},on:{"open-search":_vm.openSearch}}),_c('router-view',{key:_vm.$route.fullPath}),_c('page-footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }